export class UnauthorizedError extends Error {
  override readonly name = 'UnauthorizedError';
  constructor() {
    super('Unauthorized');
  }
}

export class NetworkError extends Error {
  override readonly name = 'NetworkError';
  constructor() {
    super('Network error');
  }
}

export class ServerError extends Error {
  override readonly name = 'ServerError';
  constructor() {
    super('Server error');
  }
}

export class TemplateNotFoundError extends Error {
  override readonly name = 'TemplateNotFoundError';
  constructor() {
    super('Workout template not found');
  }
}

export class WorkoutNotFoundError extends Error {
  override readonly name = 'WorkoutNotFoundError';
  constructor() {
    super('Workout not found');
  }
}

export class WorkoutAlreadyActiveError extends Error {
  override readonly name = 'WorkoutAlreadyActiveError';
  constructor() {
    super('An active workout already exists');
  }
}

export class InvalidWorkoutInputError extends Error {
  override readonly name = 'InvalidWorkoutInputError';
  constructor(message = 'Invalid workout input') {
    super(message);
  }
}

export class InvalidDateRangeError extends Error {
  override readonly name = 'InvalidDateRangeError';
  constructor(message = 'Invalid date range') {
    super(message);
  }
}

export class CatalogExerciseNotFoundError extends Error {
  override readonly name = 'CatalogExerciseNotFoundError';
  constructor() {
    super('Exercise not found');
  }
}

export class ExerciseNameConflictError extends Error {
  override readonly name = 'ExerciseNameConflictError';
  constructor(message = 'An exercise with this name already exists.') {
    super(message);
  }
}

export type WorkoutError =
  | UnauthorizedError
  | NetworkError
  | ServerError
  | TemplateNotFoundError
  | WorkoutNotFoundError
  | WorkoutAlreadyActiveError
  | InvalidWorkoutInputError
  | InvalidDateRangeError
  | CatalogExerciseNotFoundError
  | ExerciseNameConflictError;
